import type { ReactNode } from "react";

export type StatSize = "sm" | "md" | "lg" | "xl";

export interface StatProps {
  value: ReactNode;
  label?: ReactNode;
  sub?: ReactNode;
  size?: StatSize;
  className?: string;
}

const SIZE_CLASS: Record<StatSize, string> = {
  sm: "num-md",
  md: "text-[40px] leading-none serif tabular tracking-[-0.025em]",
  lg: "num-lg",
  xl: "num-xl",
};

export function Stat({ value, label, sub, size = "lg", className = "" }: StatProps) {
  return (
    <div className={className}>
      <div className={`${SIZE_CLASS[size]} text-[var(--ink)]`}>{value}</div>
      {label && <div className="label mt-2">{label}</div>}
      {sub && <div className="caption mt-1">{sub}</div>}
    </div>
  );
}
